import { IVuexRootState } from '@/types';
import { addDays, isFuture, parseISO } from 'date-fns';

export default {

  freeTrialState(state: IVuexRootState) {
    if (!state.user) return undefined;
    if (state.user.got_free_trial === null) return 'Available';
    if (isFuture(addDays(parseISO(state.user.got_free_trial), 1))) return 'Valid';
    return 'Completed';
  },

  isAdmin: (state: IVuexRootState) => (state.user && state.user.admin),
  isTeacher: (state: IVuexRootState) => (state.user && state.user.teacher),
  isTranslator: (state: IVuexRootState) => (state.user && state.user.translator),

  isLoggedIn: (state: IVuexRootState) => !!state.token,

  numLectureCredits(state: IVuexRootState, getters: any) {
    if (!getters.isLoggedIn) return 0;
    if (!state.user || !state.user.lect_credits) return 0;
    return state.user.lect_credits;
  },

  /* eslint-disable no-bitwise */
  playRightWrongSounds: (state: IVuexRootState) => {
    if (!state.user || !state.user.sounds) return false;
    return (state.user.sounds & 0b010) === 0b010;
  },
  playStoneClicks: (state: IVuexRootState) => {
    if (!state.user || !state.user.sounds) return false;
    return (state.user.sounds & 0b001) === 0b001;
  },
  /* eslint-enable no-bitwise */

  userId: (state: IVuexRootState) => state.user ? state.user.us_id : undefined




}
